export default "__VITE_ASSET__CJwC01eD__"